export const Vapi = {
    title: "Vapi",
    title1: "(Industrial Hub and Gateway to Daman)",

    intro: "Vapi is an industrial city in Gujarat, situated near the Arabian Sea. It serves as a key industrial hub, hosting numerous factories and industries. It also serves as the gateway to Daman, a popular coastal destination. Vapi offers a mix of modern development and scenic beauty, with nearby beaches and historical attractions.",

    attractions: [
        {
            name: "Daman Beach",
            description: "Daman Beach is a beautiful and serene beach located near Vapi, known for its peaceful atmosphere and clear waters. It's an ideal destination for relaxation, beach activities, and enjoying scenic views of the Arabian Sea.",
            location: "Daman Beach, Daman, Gujarat (Nearby Vapi)",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Relax and enjoy the sunset",
                "Engage in water sports and beach activities",
                "Take a walk along the beach",
                "Enjoy local snacks and seafood",
                "Take photographs of the scenic coastal views"
            ],
            mapLink: "https://maps.app.goo.gl/9g8v1zG1XwFb1a6J6",
        },
        {
            name: "Moti Daman Fort",
            description: "Moti Daman Fort is a historic fort located in Daman, just a short drive from Vapi. Built by the Portuguese in the 16th century, the fort offers stunning views of the sea and is a symbol of Daman's colonial past.",
            location: "Moti Daman Fort, Daman, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "₹10 per person",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore the fort and learn about its history",
                "Admire the architecture and scenic surroundings",
                "Take photographs of the fort and its walls",
                "Visit the St. Jerome Church inside the fort",
                "Enjoy the panoramic views of the sea"
            ],
            mapLink: "https://maps.app.goo.gl/JtggdJt8UPwH27tS9",
        },
        {
            name: "Jampore Beach",
            description: "Jampore Beach, located near Daman, is another peaceful and less crowded beach in the region. Known for its clean sand and gentle waves, it is perfect for swimming, picnics, and relaxing by the sea.",
            location: "Jampore Beach, Daman, Gujarat (Nearby Vapi)",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Relax and enjoy the calm beach",
                "Take a swim in the gentle waves",
                "Indulge in beach games and activities",
                "Photograph the scenic beauty of the beach",
                "Enjoy the peace and tranquility of the area"
            ],
            mapLink: "https://maps.app.goo.gl/sT8kjbYbPY6Y8brQA",
        },
        {
            name: "Daman Ganga River",
            description: "The Daman Ganga River flows through Vapi and Daman, offering a picturesque view of the river and surrounding areas. Visitors can enjoy peaceful boat rides and explore the river's surroundings, which are rich in natural beauty.",
            location: "Daman Ganga River, Vapi, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Take a peaceful boat ride on the river",
                "Enjoy photography of the river and surrounding landscape",
                "Relax along the riverbanks and enjoy the serene atmosphere",
                "Engage in birdwatching in the area",
                "Explore the river's surroundings by foot"
            ],
            mapLink: "https://maps.app.goo.gl/nYbXzNj5uM4LxYeT7",
        },
        {
            name: "Shri Swaminarayan Mandir",
            description: "The Shri Swaminarayan Mandir in Vapi is a beautiful temple dedicated to Lord Swaminarayan. Known for its magnificent architecture and spiritual significance, it attracts both pilgrims and tourists.",
            location: "Shri Swaminarayan Mandir, Vapi, Gujarat",
            timings: "5:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and aarti sessions",
                "Admire the intricate temple architecture",
                "Meditate and engage in spiritual activities",
                "Take photographs of the temple and its surroundings",
                "Learn about the teachings of Lord Swaminarayan"
            ],
            mapLink: "https://maps.app.goo.gl/jmcFcHyVzp3sVggK9",
        },
        {
            name: "Baps Shri Swaminarayan Mandir",
            description: "Another significant Swaminarayan temple located in Vapi, the Baps Shri Swaminarayan Mandir is an architectural masterpiece, offering visitors a place of peace and spiritual connection.",
            location: "Baps Shri Swaminarayan Mandir, Vapi, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Visit the temple and take part in the rituals",
                "Admire the stunning carvings and architecture",
                "Attend the evening aarti for a spiritual experience",
                "Learn about the history of the Swaminarayan tradition",
                "Take photographs of the temple's grandeur"
            ],
            mapLink: "https://maps.app.goo.gl/m7FyY19pdaWj5nA78",
        },
    ]
};
